
export const SettingItemIds = {
    accountSelfCreation: 'accountSelfCreation',
    authentication: 'authentication',
}
